import React from 'react';
import { usePhrase } from '@/hooks';
import { Button, ButtonProps } from '@mui/material';

interface SaveButtonProps {
    id: string;
    isSubmitting: boolean;
    isDisabled?: boolean;
    label: number;
    sx?: ButtonProps['sx'];
    onClick?: () => void | Promise<void>;
}

export const SaveButton = (props: SaveButtonProps) => {
    const { t } = usePhrase();
    return (
        <Button
            id={props.id}
            type="submit"
            size="large"
            loading={props.isSubmitting}
            disabled={props.isSubmitting || props.isDisabled}
            variant="contained"
            sx={props?.sx}
            onClick={props.onClick}
        >
            {t(props.label)}
        </Button>
    );
};
